import { BlankSlate, Box } from '@factorialco/deprecated-design-system'
import { AtsGetCustomizationPageFeaturesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { RejectionReasonsManager } from 'modules/ats/components/RejectionReasonsManager'
import { TagManager } from 'modules/ats/components/TagManager'
import { useAtsContext } from 'modules/ats/lib/atsContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { ReferralsSettings } from './sections/ReferralsSettings'
import { SourcesCustomization } from './sections/SourcesCustomization'

const CustomizationPage = () => {
  const { canManageAtsSettings } = useAtsContext()
  const { company } = useCurrentSession()
  const { data } = useQuery(AtsGetCustomizationPageFeaturesDocument, {
    variables: { companyId: company.id },
  })
  const showReferralsSettings = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'ats_referrals'
  )?.enabled
  const customizationFeatureAvailable = data?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === 'ats_customized_features'
  )?.available

  const rejectionReasonsFeatureAvailable = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_ats_rejection_reasons'
  )?.enabled
  const sourcesCustomizationFeatureAvailable = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'ats_sources_customization'
  )?.enabled

  return (
    <ResponsivePage.Body showHeader={false}>
      {canManageAtsSettings ? (
        <Box gap="s48">
          {showReferralsSettings && <ReferralsSettings />}
          <TagManager />
          {(customizationFeatureAvailable || rejectionReasonsFeatureAvailable) && (
            <RejectionReasonsManager />
          )}
          {(customizationFeatureAvailable || sourcesCustomizationFeatureAvailable) && (
            <SourcesCustomization />
          )}
        </Box>
      ) : (
        <BlankSlate
          illustration="settings"
          title={i18n.t('ats.settings.no_access_warning.title')}
          description={i18n.t('ats.settings.no_access_warning.description')}
          size="small"
        />
      )}
    </ResponsivePage.Body>
  )
}

export default CustomizationPage
